import { createFileRoute } from '@tanstack/react-router';

import { OrganizationSettingsPage } from '../../pages/settings';

export const Route = createFileRoute('/_shell/settings/organization')({
  component: OrganizationSettingsPage,
});
